import {
  coachHighlights,
  coachMessages,
  suggestedQuestions,
} from "./landingContent";

const SendIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M13 1L6 8M13 1L9 13L6 8M13 1L1 5L6 8"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CoachSection = () => (
  <div className="bl-coach-wrap">
    <section className="bl-coach-section" id="coach">
      <div>
        <div className="bl-coach-eyebrow">AI Coach</div>
        <h2 className="bl-coach-title">
          Ask anything.
          <br />
          Get answers that are
          <br />
          actually about you.
        </h2>
        <p className="bl-coach-sub">
          The BodyLytiX AI coach analyses your real data - your workouts, your
          sleep, your trends - and answers with context that makes advice
          useful. Not a chatbot. A coach.
        </p>
        <div className="bl-coach-checks">
          {coachHighlights.map((item) => (
            <div className="bl-coach-check" key={item}>
              <span>✓</span>
              {item}
            </div>
          ))}
        </div>
      </div>

      <div
        className="bl-coach-chat"
        aria-label="BodyLytiX coach conversation preview"
      >
        <div className="bl-chat-header">
          <div className="bl-chat-avatar">BX</div>
          <span className="bl-chat-name">BodyLytiX Coach</span>
          <div className="bl-chat-status">
            <div className="bl-status-dot" /> Active
          </div>
        </div>

        <div className="bl-chat-messages">
          {coachMessages.map((message, index) => (
            <div
              className={`bl-chat-msg ${message.from === "You" ? "bl-chat-msg--user" : "bl-chat-msg--ai"}`}
              key={`${message.from}-${index}`}
            >
              <div className="bl-chat-bubble">{message.text}</div>
              <div className="bl-chat-meta">
                {message.from} - {message.time}
              </div>
            </div>
          ))}
        </div>

        <div className="bl-chat-suggestions">
          {suggestedQuestions.map((question) => (
            <div className="bl-chat-chip" key={question}>
              {question}
            </div>
          ))}
        </div>

        <div className="bl-chat-input-row">
          <input
            className="bl-chat-input"
            type="text"
            placeholder="Ask anything about your health data..."
            disabled
          />
          <button
            className="bl-chat-send"
            type="button"
            aria-label="Send message"
            disabled
          >
            <SendIcon />
          </button>
        </div>
      </div>
    </section>
  </div>
);

export default CoachSection;
